import * as Yup from "yup";

const AddCategorySchema = (categoryNames: any, categoryDisplayNames: any) => {
  return Yup.object().shape({
    categoryName: Yup.string()
      .required(
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
      )
      .test(
        "is-in-application-list",
        "US.COLLECTION.VALIDATIONS:REQUIRED.APPLICATION_NAME_ALREADY_EXISTS",
        function (value) {
          return !categoryNames.includes(value?.toLowerCase());
        }
      ),
    displayName: Yup.string()
      .required(
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
      )
      .test(
        "is-in-application-list",
        "US.COLLECTION.VALIDATIONS:REQUIRED.DISPLAY_NAME_ALREADY_EXISTS",
        function (value) {
          return !categoryDisplayNames.includes(value?.toLowerCase());
        }
      ),
    categoryGroupId: Yup.string().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
    ),
    adapterName: Yup.string().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
    ),
    spName: Yup.string().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD"
    ),
  });
};

export default AddCategorySchema;
